export const CMS_ERRORS = {
  HOME_PAGE: {
    message: "Failed to fetch Home Page",
    code: "HOME_PAGE_ERROR"
  },
  ABOUT_PAGE: {
    message: "Failed to fetch About Page data",
    code: "ABOUT_PAGE_FETCH_ERROR"
  },
  TIME_LINE: {
    message: "Failed to fetch Timeline data",
    code: "TIME_LINE_FETCH_ERROR"
  },
  ROUTE_LIST: {
    message: "Failed to fetch Route List data",
    code: "ROUTE_LIST_FETCH_ERROR"
  },
  CAREERS_PAGE: {
    message: "Failed to fetch Careers Page data",
    code: "CAREERS_PAGE_FETCH_ERROR"
  },
  TEAM_LIST: {
    message: "Failed to fetch Team List data",
    code: "TEAM_LIST_FETCH_ERROR"
  },
  OUR_PEOPLES: {
    message: "Failed to fetch Our Peoples data",
    code: "OUR_PEOPLES_FETCH_ERROR"
  },
  OUR_BRANDS: {
    message: "Failed to fetch Our Brands data",
    code: "OUR_BRANDS_FETCH_ERROR"
  },
  FOOTER: {
    message: "Failed to fetch Footer data",
    code: "FOOTER_FETCH_ERROR"
  },
  TERMS_CONDITIONS: {
    message: "Failed to fetch Terms & Conditions",
    code: "TERMS_CONDITIONS_FETCH_ERROR"
  },
  POLICIES_PAGE: {
    message: "Failed to fetch Policies Page data",
    code: "CMS_POLICIES_PAGE_ERROR"
  },
  POLICY_SUBPAGE: {
    message: "Failed to fetch Policy Subpage data",
    code: "CMS_POLICY_SUBPAGE_ERROR"
  },
  BRAND_DATA: {
    message: "Failed to fetch Brand Data",
    code: "CMS_BRAND_DATA_ERROR"
  },
  CONTACT_SECTION: {
    message: "Failed to fetch Contact Section data",
    code: "CMS_CONTACT_SECTION_ERROR"
  },
  BAC_BRANDS: {
    message: "Failed to fetch BAC Brands data",
    code: "CMS_BAC_BRANDS_ERROR"
  },
  BRAND_STATES: {
    message: "Failed to fetch Brand States data",
    code: "CMS_BRAND_STATES_ERROR"
  },
  BRAND_LOCATIONS: {
    message: "Failed to fetch Brand Locations data",
    code: "CMS_BRAND_LOCATIONS_ERROR"
  },
  STATE_LIST: {
    message: "Failed to fetch State List data",
    code: "CMS_STATE_LIST_ERROR"
  }
};

export const CONTACT_FORM_ERROR = {
  CONTACT_FORM: {
    message: "Failed to submit Contact form",
    code: "CMS_CONTACT_FORM_ERROR"
  },
  RECAPTCHA: {
    message: "Failed to generate reCAPTCHA Token",
    code: "CMS_RECAPTCHA_ERROR"
  }
};

export const SUBSCRIBE_ERROR = {
  SUBSCRIBE_FORM: {
    message: "Failed to submit Subscribe form",
    code: "CMS_SUBSCRIBE_FORM_ERROR"
  }
};

export const POLICY_ERROR = {
  NAVIGATE_POLICY: {
    message: "Error navigating to Policy page",
    code: "POLICY_NAVIGATION_ERROR"
  }
};

export const PAGE_KEY = {
  ABOUT_US: "ABOUT_US",
  CAREER: "CAREER",
  CONTACT: "CONTACT",
  HOME: "HOME",
  POLICIES: "POLICIES",
  POLICY_SUBPAGE: "POLICY_SUBPAGE",
  TERMS_AND_CONDITIONS: "TERMS_AND_CONDITIONS"
};

export const PAGES_SENTRY_ERROR = {
  [PAGE_KEY.ABOUT_US]: "Something went wrong while loading about page.",
  [PAGE_KEY.CAREER]: "Something went wrong while loading career page.",
  [PAGE_KEY.CONTACT]: "Something went wrong while loading contact page.",
  [PAGE_KEY.HOME]: "Something went wrong while loading home page.",
  [PAGE_KEY.POLICIES]: "Something went wrong while loading policies page.",
  [PAGE_KEY.POLICY_SUBPAGE]:
    "Something went wrong while loading policy subpage.",
  [PAGE_KEY.TERMS_AND_CONDITIONS]:
    "Something went wrong while loading tearms and conditions."
};

export const JOB_LIST_ERROR = {
  message: "Failed to fetch Job List data",
  code: "JOB_LIST_FETCH_ERROR",
};